@let coilRequest = coilRequestInput();
<fieldset>
  <legend class="keyLabel">{{ fieldLabel() }}</legend>
  <div class="content">
    <div class="detailRow">
      <label class="displayLabel">Dry Bulb:</label>
      <input type="number" class="inputValue" [(ngModel)]="coilRequest.EnteringDryBulb" (change)="inputValueChange()"/>
      <label class="unitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    @if (coilRequest.isCooling) {
      <div class="detailRow">
        <label class="displayLabel">Wet Bulb:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.EnteringWetBulb" (change)="inputValueChange()"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.isFluid) {
      <div class="detailRow">
        <label class="displayLabel">Fluid Temp:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.EnteringFluidTemperature" (change)="inputValueChange()"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.isRefrigerant) {
      <div class="detailRow">
        <label class="displayLabel">Sat. Suction Temp:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.SaturationSuctionTemperature" (change)="inputValueChange()"/>
        <label class="unitLabel">{{ getTemperatureUnits() }}</label>
      </div>
    }
    @if (coilRequest.isSteam) {
      <div class="detailRow">
        <label class="displayLabel">Steam Pressure:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.EnteringSteamPressure" (change)="inputValueChange()"/>
        <label class="unitLabel">{{ getSteamPressureUnits() }}</label>
      </div>
    }
    @if (coilRequest.isFluid) {
      <div class="detailRow">
        <select class="deltaSelection" [(ngModel)]="deltaType" (change)="deltaTypeChanged()">
          <option [value]="'tempChange'">Temp Change</option>
          <option [value]="'flowRate'">Flow Rate</option>
        </select>
        <input type="number" class="inputValue" [(ngModel)]="deltaValue" (change)="deltaValueChanged()"/>
        <label class="unitLabel">{{ getDeltaUnits() }}</label>
      </div>
    }
    @if (coilRequest.FluidType) {
      <div class="detailRow">
        <label class="displayLabel">Fluid Type:</label>
        @if (coilRequest.isFluid) {
          <select class="inputSelection" [(ngModel)]="coilRequest.FluidType" (change)="fluidTypeChanged()">
            <option [value]="'W'">Water</option>
            <option [value]="'E'">Ethylene</option>
            <option [value]="'P'">Propylene</option>
          </select>
        }
        @if (!coilRequest.isFluid) {
          <label class="displayValue">{{ coilRequest.FluidType }}</label>
        }
      </div>
    }
    @if (showGlycolPercent()) {
      <div class="detailRow">
        <label class="displayLabel">Glycol:</label>
        <input type="number" class="inputValue" [(ngModel)]="coilRequest.GlycolPercentage" (change)="inputValueChange()"/>
        <label class="unitLabel">%</label>
      </div>
    }
    @if (coilRequest.isElectricHeat) {
      <div class="detailRow">
        <label class="displayLabel">E-Heat KW:</label>
        <label class="displayValue">{{ coilRequest.ElectricHeatKilowatts }}</label>
      </div>
    }
    @if (coilRequest.isElectricHeat) {
      <div class="detailRow">
        <label class="displayLabel">E-Heat Voltage:</label>
        <label class="displayValue">{{ coilRequest.ElectricHeatVoltage }}</label>
      </div>
    }
  </div>
</fieldset>
